export const HARDCODED_PAGES_WITH_ID = [
    '/leaderboard-ingame',
    '/casino-leaderboard',
    '/mystery-parcel',
    '/promotion-page'
];
